import {MolecularGraph} from "../../graph/MolecularGraph"
import {rxrExtractor} from "./rxrExtractor";
import {Features} from "../../feature";

export const etherExtractor = {
    extract: (graph: MolecularGraph) => rxrExtractor.extract("O", Features.ether, graph)
}
